import { gql } from 'apollo-angular';

export const OFFER_PREVIEW_FRAGMENT = gql`
  fragment OfferPreviewFragment on OfferPreview {
    url
  }
`;
